import ChartsService from '@/services/benchmarks/ChartsService.js';
import { getBenchmarkId, SERIES_BY_MEDIA } from '@/utils';

import { chartsMutationTypes } from '../mutation-types';

export async function fetchInteractionsAndEngagementRate({ commit, rootState, rootGetters }) {
  try {
    commit(chartsMutationTypes.INTERACTIONS_AND_ENGAGEMENT_RATE_LOADING, true);
    commit(chartsMutationTypes.INTERACTIONS_AND_ENGAGEMENT_RATE_ERROR, false);

    const groupIdListJoined = rootGetters['ui/getterGroupIdList'].join(',');

    const channelSelected = rootState.ui.channel;
    const channelListJoined = rootGetters['benchmarks/channelsLabels'].join(',');
    const handleChannelSelected = channelSelected === 'Todas' ? channelListJoined : channelSelected;

    const { series, categories } = await ChartsService.getInteractionsAndEngagementRate({
      'benchmark-id': getBenchmarkId(),
      'group-id': groupIdListJoined,
      'start-date': rootState.ui.dateRange.start,
      'end-date': rootState.ui.dateRange.end,
      channel: handleChannelSelected,
    });

    if (!Array.isArray(series) && !Array.isArray(categories)) throw new Error();

    const seriesInteractions = (serie) => {
      return ({
        ...serie,
        type: 'column',
        color: channelSelected === 'Todas'
          ? SERIES_BY_MEDIA.all.bar.color
          : SERIES_BY_MEDIA[channelSelected.toLowerCase()].bar.color,
        yAxis: 1,
      });
    };

    const seriesEngagementRate = (serie) => {
      return ({
        ...serie,
        type: 'spline',
        color: '#000',
        lineWidth: 2,
        marker: {
          radius: 4,
        },
      });
    };

    const seriesFormatGraphic = series.map((serie) => {
      let serieFormatGraphic;

      if (serie.id === 'interactions') {
        serieFormatGraphic = seriesInteractions(serie);
      } else if (serie.id === 'engagementRate') {
        serieFormatGraphic = seriesEngagementRate(serie);
      }

      return serieFormatGraphic;
    });

    commit(chartsMutationTypes.INTERACTIONS_AND_ENGAGEMENT_RATE_DATA, { series: seriesFormatGraphic, categories });
  } catch (e) {
    commit(chartsMutationTypes.INTERACTIONS_AND_ENGAGEMENT_RATE_ERROR, true);
    console.error(e);
    return e;
  } finally {
    commit(chartsMutationTypes.INTERACTIONS_AND_ENGAGEMENT_RATE_LOADING, false);
  }
}
